import React, { useEffect, useState } from "react";
import {
    ErrorReport,
    ERROR_REPORT_SEVERITY_BADGES,
    ERROR_REPORT_STATUS_BADGES,
    ERROR_REPORT_STATUS_LABELS,
    useErrorReports,
} from "../../services";

// #region MyErrorReports
// The reporter's own submissions with their current triage status. Rendered as
// the second tab of the Report an Error slideover.
export const MyErrorReports: React.FunctionComponent = (): JSX.Element => {

    const [myReports, , errorReportFunctions] = useErrorReports();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            await errorReportFunctions.getMyErrorReports();
            if (!cancelled) setLoading(false);
        };
        load();
        return () => { cancelled = true; };
        // eslint-disable-next-line
    }, []);

    if (loading) {
        return <p className="text-sm text-gray-500 dark:text-gray-400 py-6 text-center">Loading your reports…</p>;
    }

    if (myReports.length === 0) {
        return (
            <p className="text-sm text-gray-500 dark:text-gray-400 py-8 text-center">
                You haven&apos;t reported any errors yet. Anything you send will show up here with its status.
            </p>
        );
    }

    return (
        <ul className="flex flex-col gap-3 pb-10">
            {myReports.map((report: ErrorReport) => (
                <li key={report.id} className="rounded-lg border border-stone-200 dark:border-stone-700 p-3">
                    <div className="flex items-center justify-between gap-2 mb-2">
                        <div className="flex items-center gap-2">
                            <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold ${ERROR_REPORT_STATUS_BADGES[report.status]}`}>
                                {ERROR_REPORT_STATUS_LABELS[report.status]}
                            </span>
                            <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${ERROR_REPORT_SEVERITY_BADGES[report.severity]}`}>
                                {report.severity}
                            </span>
                        </div>
                        <span className="text-xs text-gray-400 whitespace-nowrap">
                            {new Date(report.created_at).toLocaleDateString()}
                        </span>
                    </div>
                    <p className="text-sm text-gray-800 dark:text-gray-200 whitespace-pre-wrap line-clamp-4">{report.description}</p>
                    {report.page_url ? (
                        <p className="text-xs text-gray-400 mt-2 truncate" title={report.page_url}>{report.page_url}</p>
                    ) : null}
                </li>
            ))}
        </ul>
    );
};
